// Locale-aware formatting (doc/20261023-i18n-zh-cn.md §3.1). Every date, number, list and sort a person reads goes
// through these with the active display language, never `undefined`, `navigator.language` or a hardcoded locale.
// Each web app wraps them in its own React hook.

const cache = new Map();

export function formattersFor(language) {
  const cached = cache.get(language);
  if (cached !== undefined) return cached;
  const collator = new Intl.Collator(language, { sensitivity: 'base', numeric: true });
  const formatters = Object.freeze({
    language,
    date: (value, options) => new Intl.DateTimeFormat(language, options).format(value),
    number: (value, options) => new Intl.NumberFormat(language, options).format(value),
    relative: (value, unit, options) => new Intl.RelativeTimeFormat(language, options).format(value, unit),
    list: (items, options) => new Intl.ListFormat(language, options).format(items),
    compare: (left, right) => collator.compare(left, right),
    // Decimal units, as the intake lists show sizes: "640 KB", "2.1 MB".
    bytes: (value) => {
      const [unit, divisor, digits] = value < 1_000 ? ['byte', 1, 0] : value < 1_000_000 ? ['kilobyte', 1_000, 0]
        : value < 1_000_000_000 ? ['megabyte', 1_000_000, 1] : ['gigabyte', 1_000_000_000, 1];
      return new Intl.NumberFormat(language, { style: 'unit', unit, unitDisplay: 'short', maximumFractionDigits: digits })
        .format(value / divisor);
    },
  });
  cache.set(language, formatters);
  return formatters;
}
